(function(){
  // Idempotent guard for the combined script
  if (window.__cqlAndClqrRegistered) return;
  window.__cqlAndClqrRegistered = true;

  // --------- CQL adjust mutation logic ---------
  function normalize(v){ return (String(v||'')).toLowerCase().trim(); }

  function runCqlAdjustMutation(){
    try{
      if (!window.liquidAjaxCart || !window.liquidAjaxCart.cart) return;
      const cart = window.liquidAjaxCart.cart;
      if (!cart.items || !cart.items.length) return;

      const groups = {};
      cart.items.forEach(li => {
        const props = li.properties || {};
        const cqlVal = props._cqlid || props.cqlid || props._cql || props.cql;
        if (!cqlVal) return;
        const key = normalize(cqlVal);
        if (!groups[key]) groups[key] = [];
        groups[key].push(li);
      });

      const requests = [];
      Object.keys(groups).forEach(k => {
        const items = groups[k];
        if (items.length <= 1) return;
        for (let i = 1; i < items.length; i++){
          const li = items[i];
          // Create new properties without fixed price flags for subsequent items
          const newProps = Object.assign({}, li.properties, {
            _bsq: '[1]',
            _bsp: '[0]'
          });
          // Remove fixed price flags so the item is charged at full price
          delete newProps._bsf;
          delete newProps._bsa;
          requests.push({
            type: 'change',
            body: {
              id: li.key,
              quantity: li.quantity,
              properties: newProps
            }
          });
        }
      });

      if (!requests.length) return;
      return { requests, lastCallback: function(){ /* no-op */ } };
    }catch(e){ console.warn('CQL adjust mutation failed', e); }
  }

  function registerCqlMutation(attempt){
    attempt = attempt || 0;
    if (!window.liquidAjaxCart || !window.liquidAjaxCart.conf){
      if (attempt < 20) return setTimeout(()=>registerCqlMutation(attempt+1), 150);
      return console.warn('liquidAjaxCart not available for CQL mutation registration');
    }
    if (window.__cqlAdjustMutationRegistered) return;
    window.liquidAjaxCart.conf('mutations', [runCqlAdjustMutation].concat(window.__existingMutations || []));
    window.__cqlAdjustMutationRegistered = true;
  }

  // --------- _cqlr injection logic ---------
  function makeRandomClqr(){
    return String(Date.now()) + String(Math.floor(Math.random()*900 + 100));
  }

  function ensureClqrOnForm(form){
    if (!form) return null;
    // Only add _cqlr when this form is a limited-qty form (has properties[_cql])
    if (!form.querySelector('input[name="properties[_cql]"]')) return null;
    var input = form.querySelector('input[name="properties[_cqlr]"]');
    if (!input){
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_cqlr]';
      form.appendChild(input);
    }
    input.value = makeRandomClqr();
    return input;
  }

  // Attach listeners after DOM ready
  document.addEventListener('DOMContentLoaded', function(){
    function attachToForms(){
      var forms = Array.prototype.slice.call(document.querySelectorAll('ajax-cart-product-form form, form.product_form, form[action*="/cart/add"]'));
      forms.forEach(function(form){
        if (!form.__clqrListenerAttached){
          form.addEventListener('submit', function(){ ensureClqrOnForm(form); }, { capture: true });
          form.__clqrListenerAttached = true;
        }
      });
    }
    attachToForms();

    // delegate clicks for quick-add buttons
    document.body.addEventListener('click', function(e){
      var target = e.target;
      var btn = target.closest && target.closest('button[name="add"], button[type="submit"], .cart-submit');
      if (!btn) return;
      var form = btn.closest && btn.closest('form');
      if (form) ensureClqrOnForm(form);
    }, { passive: true });
  });

  // Also hook ensureClqrOnForm into the theme's ajax-cart lifecycle so ajax adds get a fresh value
  document.addEventListener('liquid-ajax-cart:request-start', function(ev){
    try{
      var requestState = (ev && ev.detail && ev.detail.requestState) || null;
      if (!requestState) return;
      var initiator = requestState.info && requestState.info.initiator;
      if (initiator && typeof initiator.closest === 'function'){
        var form = initiator.closest('form');
        if (form) ensureClqrOnForm(form);
      } else {
        var productForm = document.querySelector('ajax-cart-product-form form') || document.querySelector('form.product_form') || document.querySelector('form[action*="/cart/add"]');
        if (productForm) ensureClqrOnForm(productForm);
      }
    }catch(e){ /* swallow errors */ }
  });

  // Finally register the CQL mutation (attempts until available)
  registerCqlMutation();
})();
